module.exports = __webpack_public_path__ + "static/social_media_management_platform_image-1d1b88af61b32d61f80ef898944311f7.png";